import { InjectionToken } from '@angular/core'
import { Converter } from '@spartacus/core'
import { EbRfpFormInterface, EbRfpFormOccInterface } from '../interfaces/eb-rfp.interface'

export const RFP_FORM_SERIALIZER = new InjectionToken<
  Converter<EbRfpFormInterface, EbRfpFormOccInterface>
>('RfpFormSerializer')
